<template>
  <PartnersLayout>
    <template #header>
      <PartnersHeader
        title="꾸우챗 광고 신청"
        subtitle="꾸우챗 결과 상단에 노출되는 광고 (무료)"
      />
    </template>

    <div class="px-4 lg:px-6 pb-6">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- 왼쪽: 안내 및 바로가기 -->
          <div class="lg:col-span-1 space-y-4">
            <!-- 안내 카드 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <div class="flex items-center gap-2 mb-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 class="font-semibold text-slate-800">꾸우챗 광고 안내</h3>
              </div>
              <ul class="text-sm text-slate-600 space-y-2">
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 등록은 <strong class="text-blue-700">무료</strong>입니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>신청 후 <strong class="text-blue-700">관리자 승인</strong>이 필요합니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 기간은 <strong class="text-blue-700">1주일</strong>입니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>계정당 <strong class="text-blue-700">1개</strong>만 등록 가능</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 유입 콜은 <strong class="text-blue-700">건당 10,000P</strong>에 구매</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>꾸우챗 결과 <strong class="text-blue-700">상단</strong>에 현장 카드 노출</span>
                </li>
              </ul>
            </div>

            <!-- 바로가기 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <h3 class="font-semibold text-slate-800 mb-3">바로가기</h3>
              <div class="space-y-2">
                <router-link
                  to="/partners/chatad/my"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">내 꾸우챗 광고</p>
                    <p class="text-xs text-slate-500">신청 현황 확인</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link
                  to="/partners/ad/create"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">캠페인 만들기</p>
                    <p class="text-xs text-slate-500">광고에 필요한 캠페인 생성</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
              </div>
            </div>
          </div>

          <!-- 오른쪽: 메인 콘텐츠 -->
          <div class="lg:col-span-2">
            <!-- 로딩 -->
            <div v-if="loading" class="bg-white rounded-2xl border border-slate-200 p-12 text-center">
              <div class="spinner mx-auto mb-4"></div>
              <p class="text-slate-500">데이터를 불러오는 중...</p>
            </div>

            <!-- 이미 광고가 있는 경우 -->
            <div v-else-if="hasActiveAd" class="bg-amber-50 border border-amber-200 rounded-2xl p-6">
              <div class="flex items-start gap-3">
                <svg class="w-6 h-6 text-amber-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
                <div>
                  <p class="font-semibold text-amber-800">이미 등록된 광고가 있습니다</p>
                  <p class="text-sm text-amber-600 mt-1">계정당 1개의 광고만 등록할 수 있습니다.</p>
                  <p class="text-sm text-amber-600">기존 광고가 만료되거나 삭제된 후 새로운 광고를 신청해주세요.</p>
                  <router-link
                    to="/partners/chatad/my"
                    class="inline-flex items-center gap-1 mt-3 text-sm text-blue-600 font-medium hover:underline"
                  >
                    내 광고 확인하기
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- 캠페인 없음 안내 -->
            <div v-else-if="campaigns.length === 0" class="bg-amber-50 border border-amber-200 rounded-2xl p-6">
              <div class="flex items-center gap-3">
                <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
                <div>
                  <p class="font-semibold text-amber-800">활성화된 캠페인이 없습니다</p>
                  <p class="text-sm text-amber-600">꾸우챗 광고를 등록하려면 먼저 캠페인을 생성해주세요.</p>
                  <router-link to="/partners/ad/create" class="inline-flex items-center gap-1 mt-2 text-sm text-blue-600 font-medium hover:underline">
                    캠페인 만들기
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>

            <div v-else class="space-y-4">
              <!-- 캠페인 선택 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">1. 캠페인 선택</h2>

                <div class="space-y-3">
                  <label
                    v-for="campaign in campaigns"
                    :key="campaign.id"
                    :class="[
                      'flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition',
                      selectedCampaign?.id === campaign.id
                        ? 'border-blue-500 bg-blue-50'
                        : 'border-slate-200 hover:border-blue-300'
                    ]"
                  >
                    <input
                      type="radio"
                      :value="campaign"
                      v-model="selectedCampaign"
                      class="w-5 h-5 text-blue-600"
                    />
                    <div class="flex-1">
                      <h3 class="font-semibold text-slate-800">{{ campaign.propertyName }}</h3>
                      <p class="text-sm text-slate-500">캠페인 코드: {{ campaign.code }}</p>
                      <p class="text-xs text-slate-400 mt-1">만료일: {{ campaign.endDate }}</p>
                    </div>
                    <span class="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
                      활성
                    </span>
                  </label>
                </div>
              </div>

              <!-- 시간대 선택 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-2">2. 노출 시간대 선택</h2>
                <p class="text-sm text-slate-500 mb-4">광고가 노출될 시간대를 선택하세요. (1개만 선택 가능)</p>

                <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
                  <button
                    v-for="slot in timeSlots"
                    :key="slot.id"
                    type="button"
                    @click="selectedTimeSlot = slot"
                    :class="[
                      'p-3 rounded-xl border-2 text-left transition',
                      selectedTimeSlot?.id === slot.id
                        ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-500/20'
                        : 'border-slate-200 hover:border-blue-300 hover:bg-blue-50/50'
                    ]"
                  >
                    <p :class="['text-sm font-medium', selectedTimeSlot?.id === slot.id ? 'text-blue-700' : 'text-slate-700']">{{ slot.label }}</p>
                    <p :class="['text-xs mt-0.5', selectedTimeSlot?.id === slot.id ? 'text-blue-500' : 'text-slate-400']">{{ slot.start }}-{{ slot.end }}</p>
                  </button>
                </div>
              </div>

              <!-- 이미지 업로드 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-2">3. 광고 이미지 업로드</h2>
                <p class="text-sm text-slate-500 mb-4">프로퍼티 썸네일과 동일한 16:9 비율의 이미지를 권장합니다.</p>

                <div class="space-y-4">
                  <!-- 업로드 영역 -->
                  <div
                    @click="triggerFileInput"
                    @dragover.prevent="isDragging = true"
                    @dragleave.prevent="isDragging = false"
                    @drop.prevent="handleFileDrop"
                    :class="[
                      'relative border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition',
                      isDragging ? 'border-blue-500 bg-blue-50' : 'border-slate-300 hover:border-blue-400'
                    ]"
                  >
                    <input
                      ref="fileInputRef"
                      type="file"
                      accept="image/*"
                      class="hidden"
                      @change="handleFileSelect"
                    />

                    <div v-if="!imagePreview" class="space-y-2">
                      <svg class="w-12 h-12 mx-auto text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                      </svg>
                      <p class="text-sm text-slate-600">클릭하거나 이미지를 드래그하세요</p>
                      <p class="text-xs text-slate-400">권장: 16:9 비율 (1280x720 이상)</p>
                    </div>

                    <div v-else class="space-y-3">
                      <div class="aspect-video max-w-md mx-auto rounded-lg overflow-hidden bg-slate-100">
                        <img :src="imagePreview" alt="미리보기" class="w-full h-full object-cover" />
                      </div>
                      <button
                        @click.stop="removeImage"
                        class="text-sm text-red-600 hover:underline"
                      >
                        이미지 삭제
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 광고 문구 작성 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">4. 광고 문구 작성</h2>

                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-slate-600 mb-2">제목 (필수)</label>
                    <input
                      v-model="adTitle"
                      type="text"
                      maxlength="30"
                      placeholder="예: 래미안 원베일리 특별분양"
                      class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none"
                    />
                    <p class="text-xs text-slate-400 mt-1">{{ adTitle.length }}/30자</p>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-slate-600 mb-2">한줄 소개 (필수)</label>
                    <input
                      v-model="adSubtitle"
                      type="text"
                      maxlength="50"
                      placeholder="예: 강남 핵심 입지, 프리미엄 주거단지"
                      class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none"
                    />
                    <p class="text-xs text-slate-400 mt-1">{{ adSubtitle.length }}/50자</p>
                  </div>
                </div>
              </div>

              <!-- 미리보기 -->
              <div v-if="canPreview" class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">5. 미리보기</h2>
                <p class="text-sm text-slate-500 mb-4">꾸우챗 결과 상단에 아래와 같이 노출됩니다.</p>

                <!-- 현장 카드 미리보기 -->
                <div class="max-w-sm">
                  <div class="result-card bg-blue-50 border-2 border-blue-300">
                    <div class="card-thumb">
                      <img v-if="imagePreview" :src="imagePreview" alt="광고 이미지" />
                      <div v-else class="thumb-empty">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                          <polyline points="9,22 9,12 15,12 15,22"/>
                        </svg>
                      </div>
                      <span class="card-badge ad-badge">AD</span>
                    </div>
                    <div class="card-info">
                      <span class="card-region">{{ selectedCampaign?.propertyName?.split(' ')[0] || '지역' }}</span>
                      <h4 class="card-name">{{ adTitle || '광고 제목' }}</h4>
                      <p class="card-subtitle">{{ adSubtitle || '한줄 소개' }}</p>
                    </div>
                  </div>
                </div>

                <!-- 노출 정보 -->
                <div v-if="selectedTimeSlot" class="mt-4 p-4 bg-blue-50 rounded-xl">
                  <div class="flex items-center gap-2 text-blue-700">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    <span class="font-medium">노출 시간: {{ selectedTimeSlot.label }} ({{ selectedTimeSlot.start }} - {{ selectedTimeSlot.end }})</span>
                  </div>
                  <p class="text-sm text-blue-600 mt-1">승인 후 1주일간 꾸우챗 결과 상단에 노출됩니다.</p>
                </div>
              </div>

              <!-- 신청 버튼 -->
              <button
                v-if="canSubmit"
                @click="handleSubmit"
                :disabled="submitting"
                class="w-full py-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {{ submitting ? '신청 중...' : '광고 신청하기 (무료)' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PartnersLayout>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import PartnersLayout from '@/components/partners/common/PartnersLayout.vue'
import PartnersHeader from '@/components/partners/common/PartnersHeader.vue'
import { useAuth } from '@/composables/common/useAuth'
import { useChatAd } from '@/composables/partners/useChatAd'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { db, storage } from '@/firebase/firebase'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'

export default {
  name: 'ChatAdPurchaseView',
  components: {
    PartnersLayout,
    PartnersHeader
  },
  setup() {
    const router = useRouter()
    const { user, userProfile } = useAuth()
    const { TIME_SLOTS, createChatAd, checkExistingChatAd } = useChatAd()

    const loading = ref(true)
    const campaigns = ref([])
    const selectedCampaign = ref(null)
    const selectedTimeSlot = ref(null)
    const adTitle = ref('')
    const adSubtitle = ref('')
    const submitting = ref(false)
    const hasActiveAd = ref(false)

    // 이미지 관련
    const fileInputRef = ref(null)
    const isDragging = ref(false)
    const imageFile = ref(null)
    const imagePreview = ref(null)
    const uploading = ref(false)

    const timeSlots = TIME_SLOTS

    const canPreview = computed(() => {
      return selectedCampaign.value && adTitle.value.trim()
    })

    const canSubmit = computed(() => {
      return selectedCampaign.value &&
             selectedTimeSlot.value &&
             adTitle.value.trim() &&
             adSubtitle.value.trim() &&
             imagePreview.value
    })

    // 파일 입력 트리거
    const triggerFileInput = () => {
      fileInputRef.value?.click()
    }

    // 파일 선택 핸들러
    const handleFileSelect = (e) => {
      const file = e.target.files?.[0]
      if (file) processFile(file)
    }

    // 드래그 앤 드롭 핸들러
    const handleFileDrop = (e) => {
      isDragging.value = false
      const file = e.dataTransfer?.files?.[0]
      if (file) processFile(file)
    }

    // 파일 처리
    const processFile = (file) => {
      if (!file.type.startsWith('image/')) {
        alert('이미지 파일만 업로드할 수 있습니다.')
        return
      }

      if (file.size > 5 * 1024 * 1024) {
        alert('파일 크기는 5MB 이하여야 합니다.')
        return
      }

      imageFile.value = file

      const reader = new FileReader()
      reader.onload = (e) => {
        imagePreview.value = e.target?.result
      }
      reader.readAsDataURL(file)
    }

    // 이미지 삭제
    const removeImage = () => {
      imageFile.value = null
      imagePreview.value = null
      if (fileInputRef.value) {
        fileInputRef.value.value = ''
      }
    }

    // 이미지 업로드
    const uploadImage = async () => {
      if (!imageFile.value) return null

      uploading.value = true
      try {
        const timestamp = Date.now()
        const fileName = `chatads/${user.value.uid}/${timestamp}_${imageFile.value.name}`
        const imageRef = storageRef(storage, fileName)

        await uploadBytes(imageRef, imageFile.value)
        const downloadURL = await getDownloadURL(imageRef)

        return downloadURL
      } catch (err) {
        console.error('이미지 업로드 실패:', err)
        throw err
      } finally {
        uploading.value = false
      }
    }

    // 활성 캠페인 로드
    const loadCampaigns = async () => {
      if (!user.value) return

      try {
        const q = query(
          collection(db, 'campaigns'),
          where('partnerId', '==', user.value.uid),
          where('status', '==', 'active')
        )
        const snapshot = await getDocs(q)

        campaigns.value = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

        // 캠페인이 하나면 자동 선택
        if (campaigns.value.length === 1) {
          selectedCampaign.value = campaigns.value[0]
        }
      } catch (err) {
        console.error('캠페인 로드 실패:', err)
      }
    }

    const handleSubmit = async () => {
      if (!canSubmit.value || submitting.value) return

      // 다시 한번 확인
      const exists = await checkExistingChatAd(user.value.uid)
      if (exists) {
        alert('이미 등록된 광고가 있습니다.\n기존 광고가 만료되거나 삭제된 후 새로운 광고를 신청해주세요.')
        hasActiveAd.value = true
        return
      }

      if (!confirm('광고를 신청하시겠습니까?\n관리자 승인 후 1주일간 꾸우챗 결과에 노출됩니다.')) {
        return
      }

      submitting.value = true

      try {
        // 이미지 업로드
        const imageUrl = await uploadImage()
        if (!imageUrl) {
          alert('이미지 업로드에 실패했습니다.')
          return
        }

        // 광고 신청 생성
        await createChatAd({
          partnerId: user.value.uid,
          partnerEmail: user.value.email,
          partnerDisplayName: userProfile.value?.name || user.value.email,
          propertyId: selectedCampaign.value.propertyId,
          propertyName: selectedCampaign.value.propertyName,
          campaignId: selectedCampaign.value.id,
          campaignCode: selectedCampaign.value.code,
          imageUrl: imageUrl,
          title: adTitle.value.trim(),
          subtitle: adSubtitle.value.trim(),
          linkUrl: `/p/${selectedCampaign.value.code}`,
          timeSlot: {
            id: selectedTimeSlot.value.id,
            label: selectedTimeSlot.value.label,
            start: selectedTimeSlot.value.start,
            end: selectedTimeSlot.value.end
          }
        })

        alert('광고 신청이 완료되었습니다!\n관리자 승인 후 1주일간 꾸우챗 결과에 노출됩니다.')

        // 내 광고 페이지로 이동
        router.push('/partners/chatad/my')
      } catch (err) {
        console.error('광고 신청 실패:', err)
        alert('신청 실패: ' + err.message)
      } finally {
        submitting.value = false
      }
    }

    onMounted(async () => {
      loading.value = true

      // 기존 광고 확인
      if (user.value) {
        hasActiveAd.value = await checkExistingChatAd(user.value.uid)
      }

      // 캠페인 로드
      if (!hasActiveAd.value) {
        await loadCampaigns()
      }

      loading.value = false
    })

    return {
      loading,
      campaigns,
      selectedCampaign,
      selectedTimeSlot,
      timeSlots,
      adTitle,
      adSubtitle,
      canPreview,
      canSubmit,
      submitting,
      hasActiveAd,
      userProfile,
      fileInputRef,
      isDragging,
      imagePreview,
      triggerFileInput,
      handleFileSelect,
      handleFileDrop,
      removeImage,
      handleSubmit
    }
  }
}
</script>

<style scoped>
@reference "tailwindcss";

.spinner {
  @apply w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin;
}

/* 결과 카드 미리보기 스타일 */
.result-card {
  display: flex;
  gap: 12px;
  padding: 12px;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.card-thumb {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f0f0f0;
}

.card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumb-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbb;
}

.card-badge {
  position: absolute;
  top: 4px;
  left: 4px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 4px;
}

.ad-badge {
  background: rgba(37, 99, 235, 0.95);
  color: #fff;
}

.card-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.card-region {
  font-size: 12px;
  color: #888;
}

.card-name {
  font-size: 14px;
  font-weight: 600;
  color: #111;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-subtitle {
  font-size: 12px;
  color: #666;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
